import { supabase } from '@/utils/supabase';

const LOAN_DOCUMENTS_BUCKET = 'loan-documents';

/**
 * Reserve an exact object key for an authorized loan before a browser upload.
 *
 * Storage RLS cannot infer a loan from historical path conventions. The
 * reservation is therefore the authoritative object-to-loan binding and must
 * exist before Storage evaluates an INSERT for a scoped LO/LOA.
 */
export async function reserveLoanStorageObject(
  objectName: string,
  encompassLoanId: string
): Promise<void> {
  const { error } = await supabase.rpc('reserve_loan_storage_object', {
    p_bucket_id: LOAN_DOCUMENTS_BUCKET,
    p_object_name: objectName,
    p_encompass_loan_id: encompassLoanId
  });

  if (error) {
    throw new Error(`Document upload authorization failed: ${error.message}`);
  }
}
